import { VERIFY_EMAIL, VERIFY_EMAIL_DONE, VERIFY_EMAIL_ERR, RESET_EMAIL_VERIFICATION } from './actionTypes';
export const verifyEmail = (data) => ({
    type: VERIFY_EMAIL,
    data
});
export const doneVerifyingEmail = (data) => ({
    type: VERIFY_EMAIL_DONE,
    data
});
export const errorVerifyingEmail = (data) => ({
    type: VERIFY_EMAIL_ERR,
    errorMessage: data
});
export const resetEmailVerification = () => ({
    type: RESET_EMAIL_VERIFICATION
});
//# sourceMappingURL=actionCreators.js.map